/**
 * Strips the "layer" prefix and lowercases the first letter.
 * e.g. "layerComp" → "comp", "layerEventName" → "eventName"
 */
export function formatPropertyName(name: string): string {
  return lowerFirstLetter(name.replace(/^layer\.*/, ''));
}

function lowerFirstLetter(str: string): string {
  return str.charAt(0).toLowerCase() + str.slice(1);
}

export function decodeHtmlEntities(str: string): string {
  return str.replace(/&quot;/g, '"').replace(/&apos;/g, "'").replace(/&amp;/g, '&');
}

export function normalizeToCsvString(value: unknown): string {
  if (Array.isArray(value)) {
    return (value as unknown[]).filter(Boolean).join(', ');
  }
  if (value === null || value === undefined) {
    return '';
  }
  return String(value);
}

export function applyTagFields(data: Record<string, any>, obj: Record<string, any>): void {
  if (!obj || typeof obj !== 'object') return;
  const { tags, personas, supportPersona, supportTopics, businessUnit, supportProducts, programsSolutions } = obj;
  const persona = supportPersona || personas;
  if (tags && !data.tags) data.tags = normalizeToCsvString(tags);
  if (persona && !data.supportPersona) data.supportPersona = normalizeToCsvString(persona);
  if (supportTopics && !data.supportTopics) data.supportTopics = normalizeToCsvString(supportTopics);
  if (businessUnit && !data.businessUnit) data.businessUnit = normalizeToCsvString(businessUnit);
  // prefer programsSolutions over supportProducts
  if (programsSolutions && !data.supportProducts) data.supportProducts = normalizeToCsvString(programsSolutions);
  if (supportProducts && !data.supportProducts) data.supportProducts = normalizeToCsvString(supportProducts);
}
